/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResultStates = {
    Success: 'Success',
    SuccessNoData: 'SuccessNoData',
    Error: 'Error',
    ValidationError: 'ValidationError',
    IsNotFoundError: 'IsNotFoundError',
    DisplayError: 'DisplayError',
    NullError: 'NullError',
    Unauthorized: 'Unauthorized',
    Forbidden: 'Forbidden'
} as const;
export type ResultStates = typeof ResultStates[keyof typeof ResultStates];


export function ResultStatesFromJSON(json: any): ResultStates {
    return ResultStatesFromJSONTyped(json, false);
}

export function ResultStatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultStates {
    return json as ResultStates;
}

export function ResultStatesToJSON(value?: ResultStates | null): any {
    return value as any;
}

